export default function MyDivider({ className }: { className: string }) {
  return <div className={` w-0.5 bg-[#9d9d9d] ${className} `} />;
}
